import { setShelterName, setKojinInfo } from './actions';
import config from './../../config/config.js';
import { push } from 'connected-react-router';
import axios from 'axios';


//個人情報取得
const getKojin = (knum, uuid, snum, flg) => {
  return async(dispatch, getState) => {

    console.log('------getKojin------');
    console.log('knum', knum);
    console.log('uuid', uuid);
    console.log('snum', snum);
    console.log('flg', flg);
    
    let url = "";
    let mode = "";
    
    //クエリー指定
    if ( flg === 'K' ) {
      url = config.API_MethodName_Evacuee;
      mode = "1";
    } else {
      url = config.API_MethodName_Evacuees;
      mode = "3";
    }

    console.log('mode', mode);

    const header = {'Access-Control-Allow-Origin' : "*"};
    const param = {
          'app' : config.Kintone_ApiId_Kojin,
          'totalCount' : 'true',
          'personalNumber': knum,
          'householdNumber': snum,
          'UUIDTextFiled': uuid,
          'mode': mode 
    };
    console.log('param', param);
    return await axios.get(url, {
      withCredentials: true,
      params: param
    });
  };
};


//世帯・個人情報登録
const setKojin = (count) => {
  return async(dispatch, getState) => {

    console.log('------setKojin------');

    let state = getState();
    let values = state.form.Infoupd.values;

    let kojinRows  = [];
    let householdNumber = "";
    let personalNumber = "";
    let representative = "";
    let representativeFlg = false;

    //退所日時を設定
    //※Kintone側の仕様のため日本時間（JST）は＋9：00を設定する
    let leaveDate = new Date().getFullYear() + '-'
      + ('0' + (new Date().getMonth() +1)).slice(-2) + '-'
      + ('0' + new Date().getDate()).slice(-2) + 'T'
      + ('0' + new Date().getHours()).slice(-2) + ':'
      + ('0' + new Date().getMinutes()).slice(-2) + ':00+09:00';

    //個人情報設定
    for( var i=1; i<=count; i++){

      personalNumber = values["personalNumber_" + i ];

      representative = "" ;
      if ( "representative_" + i  in values ) { 
          if( values["representative_" + i ][0] === "1" ) {
            representative = "代表者"; 
            representativeFlg = true;
          }
      }
      // 個人情報生成
      let row = {
          "updateKey" : { "field" : "personalNumber", "value" : personalNumber },
          "record" : {
          }
      };
      if (representative === "" ){
        row.record.RepresentativeCheckBox = { "type" : "CHECK_BOX", "value" : [] };
      } else {            
        row.record.RepresentativeCheckBox = { "type" : "CHECK_BOX", "value" : [ representative ] };
      }
      
      kojinRows.push(row);

    }

    // QR読み込んだ対象者の個人番号を取得
    personalNumber = values["personalNumber_0"];

    // 個人情報生成
    let row = {
        "updateKey" : { "field" : "personalNumber", "value" : personalNumber },
        "record" : {
          "status" : { "value" : values["status_0"] }
        }
    };

    //  退所の場合、退所日時を更新
    if( values["status_0"] === "退所") {
      row.record.leaveDate = { "value" : leaveDate };
    }
    //  代表者が退所した場合、代表者フラグを初期化
    if( representativeFlg === true && values["representative_0" ][0] === "1"  ) {
      row.record.RepresentativeCheckBox = { "type" : "CHECK_BOX", "value" : [] };
    }

    kojinRows.push(row);

    const header = {'Access-Control-Allow-Origin' : "*"};
    const param = {
        'parameter': {
            'requests': [
              {
                'method' : 'PUT',
                'api' : '/k/v1/records.json',
                'payload': {
                  'app' : config.Kintone_ApiId_Kojin,
                  'records' : kojinRows
                }
              }
            ]
        }
    };

    console.log('param', param);
    return await axios.put(config.API_MethodName_Evacuees, param, {
      withCredentials: true
    });

   };
};

//避難所名セット
const setShelterNameOperation = (value) => {
  return async (dispatch, getState) => {
    console.log(value);
    dispatch(setShelterName(value));
  };
};

//登録済み個人情報storeセット
const setRegisteredKojinInfoListOperation = (idx,values) => {
  return async (dispatch, getState) => {
    console.log('------updateWorkOperation------');
    console.log(values);
    let list = [];
    const param = {
      idx:idx,
      personalNumber:values.personalNumber.value,
      uuid:values.UUIDTextFiled.value,
      representative:values.RepresentativeCheckBox.value,
      personalName:values.PersonalNameTextFiled.value,
      status:values.status.value,
      outFlag:"1"
    }
    list[idx-1]=param;
    dispatch(setKojinInfo(list));
  };
};

export default {
  setShelterNameOperation,
  setRegisteredKojinInfoListOperation,
  getKojin,
  setKojin
};
